import { useFinanceSimulationSelector } from "@redux/reducers/deal";
import { getIsLeasingJourneySelected } from "@shared/v2/lib/getIsLeasingJourneySelected";

export const useIsLeasingJourneySelected = () => {
  const financeSimulation = useFinanceSimulationSelector();

  return getIsLeasingJourneySelected(financeSimulation.journey);
};
